import Blanja from "../../assets/blanja.jpg";
import pijarFoodMobile from "../../assets/pijarFoodMobile.png";
import pijarFood from "../../assets/pijarFood.jpg";
import Influenzailla from "../../assets/Influenzailla.jpg";
import Peworld from "../../assets/peworld.jpg";

export const projectsData = [
  {
    id: 1,
    image: Influenzailla,
    title: "Influenzailla",
    category: "design",
    link: "https://muhammadsonysetiawan.github.io/Influenzailla/",
    imgReview: Influenzailla,
    github: "https://github.com/MuhammadSonySetiawan/Influenzailla",
  },
  {
    id: 2,
    image: pijarFoodMobile,
    title: "Pijar Food Mobile",
    category: "app",
    link: "https://github.com/MuhammadSonySetiawan/pijar-food-mobile/releases",
    imgReview: pijarFoodMobile,
    github: "https://github.com/MuhammadSonySetiawan/pijar-food-mobile",
  },
  {
    id: 3,
    image: pijarFood,
    title: "Pijar Food",
    category: "web",
    link: "https://pijar-food-website.vercel.app/",
    imgReview: pijarFood,
    github: "https://github.com/MuhammadSonySetiawan/pijar-food-website",
  },
  {
    id: 4,
    image: Peworld,
    title: "Peworld",
    category: "web",
    link: "https://peworld-lilac.vercel.app/",
    imgReview: Peworld,
    github: "https://github.com/MuhammadSonySetiawan/Peworld",
  },
  {
    id: 5,
    image: Blanja,
    title: "Blanja",
    category: "web",
    link: "https://blanja-fe-zeta.vercel.app/",
    imgReview: Blanja,
    github: "https://github.com/MuhammadSonySetiawan/blanja",
  },
  // {
  //   id: 4,
  //   image: Work4,
  //   title: "App movil",
  //   category: "app",
  //   link: "",
  //   imgReview: "",
  //   github: "",
  // },
];


export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },
  {
    name: "design",
  },
];